export function CheckedIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#035462" />
      <path
        d="M17.729 8.76611L10.479 16.0161L7.18359 12.7207"
        stroke="white"
        strokeWidth="1.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
